import { render, staticRenderFns } from "./DetailFloat.vue?vue&type=template&id=5dae10d1"
import script from "./DetailFloat.vue?vue&type=script&lang=js"
export * from "./DetailFloat.vue?vue&type=script&lang=js"
import style0 from "./DetailFloat.vue?vue&type=style&index=0&id=5dae10d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports